import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";

export const Route = createFileRoute("/")({ component: Index });

function Index() {
  const { loading, user, role } = useAuth();
  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" />;
  if (role === "admin" || role === "moderator")
    return <Navigate to="/admin/overview" />;
  return <Navigate to="/dashboard" />;
}
